export const BigCommerceCategoriesMap = {
  23: 'shop-all',
  24: 'magazines',
  26: 'magbooks',
  27: 'subscriptions',
};

export const BigCommerceSubscriptionSKU = 'subscription-01';
